module.exports = __webpack_public_path__ + "static/media/17-6.29326a4a.mp3";